import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/${dossierId}/ContactComponentHistorical`, method: 'GET', token: token })
}
